<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="config-box">
          <el-form
            ref="form"
            :model="form"
            class="form custom-form"
            :rules="rulesFour"
            label-position="top"
          >
            <el-form-item>将向 {{ form.phone }} 发送短信</el-form-item>
            <el-form-item prop="sms" label="验证码">
              <el-input
                v-model.trim="form.sms"
                placeholder="请输入短信验证码"
                id="code"
                maxLength="8"
              >
                <div
                  slot="suffix"
                  class="code-image"
                  :class="disabled ? 'code-image-disable' : ''"
                  @click="disabled ? '' : getMsg()"
                >
                  {{ innerTxt }}
                </div>
              </el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input
                v-model="form.newPassword"
                clearable
                style="width: 100%"
                type="password"
                autocomplete="off"
                show-password
                placeholder="请输入新密码"
                maxlength="30"
              />
            </el-form-item>
            <el-form-item label="确认新密码" prop="recheckNewPassword">
              <el-input
                v-model="form.recheckNewPassword"
                clearable
                style="width: 100%"
                type="password"
                show-password
                autocomplete="off"
                placeholder="请输入确认新密码"
                maxlength="30"
              />
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button type="default" @click.stop="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click.stop="submitForm()"
          :loading="dialogObj.btnLoading"
          >确认</el-button
        >
      </template>
    </DialogContainer>
  </div>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validatePhone } from "@/utils/validate";
import { changePhoneSms, forgetPassSms, updatePass } from "@/views/login/api";
export default {
  name: "UpdatePassword",
  components: {
    DialogContainer,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.form.recheckPassword !== "") {
        this.$refs.form.validateField("recheckPassword");
      }
      callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error("两次输入的新密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      timer: null,
      disabled: false,
      innerTxt: "获取验证码",
      isDisabled: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "修改密码",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          this.isDisabled = false;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      // 账号配置
      form: {
        phone: "",
        sms: "",
        newPassword: "",
        recheckNewPassword: "",
      },
      rulesFour: {
        sms: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          { validator: validatePhone, trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码" },
          { validator: validatePass, trigger: "blur" },
        ],
        recheckNewPassword: [
          { required: true, message: "请确认新密码" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    setTimer() {
      let time = 60;
      // 禁用按钮
      this.disabled = true;
      // 开启定时器
      this.timer = setInterval(() => {
        // 判断剩余时间
        if (time === 0) {
          // 清除定时器并复原按钮
          clearInterval(this.timer);
          this.disabled = false;
          this.innerTxt = `获取验证码`;
        } else {
          this.innerTxt = `${time}秒后可重新获取`;
          time--;
        }
      }, 1000);
    },
    // 判断是否需要验证码登录
    getMsg() {
      forgetPassSms(this.form.phone).then((res) => {
        if (res.code === 200) {
          this.setTimer();
        }
      });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let par = {
            password: this.form.newPassword,
            phone: this.form.phone,
            sms: this.form.sms,
          };
          updatePass(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("修改成功");
                setTimeout(() => {
                  localStorage.clear();
                  this.$router.replace({ name: "Login" });
                }, 300);
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    handleCancel() {
      this.dialogObj.beforeClose();
    },
    handleClick() {},
    init(phone) {
      this.form.phone = phone;
      this.dialogObj.show = true;
    },
  },
};
</script>
<style lang="scss">
.custom-form {
  .second-form {
    .form-two-box {
      .el-checkbox__label {
        color: #718096;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.config-box {
  padding: 0 0.2rem 0;
  .code-image {
    width: 1.2rem;
    height: 0.32rem;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
  //min-height: rem;
  .third-form {
    .form-one {
      padding-left: 0.1rem;
    }
    .form-two {
      padding-left: 0.9rem;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
    }
  }
  .second-form {
    .form-one {
      padding-left: 0.1rem;
    }
    .form-two {
      display: flex;
      padding-left: 0.9rem;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
      flex-wrap: wrap;
      .form-two-box {
        width: 2rem;
        padding: 0.1rem 0;
      }
    }
  }
}
</style>
